import keycloak from "keycloak";
import salesforceAuth from "salesforceAuth";

// LOGIN_PROVIDER in UepAppData picks how users log in: "salesforce" or (default) Keycloak.
export const isSalesforceLogin = () =>
  (window.UepAppData || {}).LOGIN_PROVIDER === "salesforce";

const authClient = isSalesforceLogin() ? salesforceAuth : keycloak;

export default authClient;
